export default __webpack_public_path__ + "static/media/Icons_Marina_LightGrey Icon.d2872f7d.svg";